import React, { Component } from 'react'
import { observable, computed, action } from 'mobx'
import { observer, inject } from 'mobx-react'
import { Form, Select, Button, Modal, Row } from 'antd'
import { selectInput } from '../../EditSubStoDataPopup/edit-sub-sto.scss'

const { Item: FormItem } = Form

// ── constants ────────────────────────────────────────────────
const rightLabel = { labelCol: { style: { textAlign: 'right' as 'right' } } }

// const productNameMap = {
//     'מגן דוד כחול': 'magen-david-k',
//     'עד 120': 'nursing',
//     'תושבי חוץ': 'Best Care non-res',
//     'Bundle Soul Best Care': 'Soul+Best Care',
//     'Bundle Soul Gold': 'Soul Care+gold',
//     'Bundle Simple Smile Best Care': 'Simple Smile+Best Care',
//     'Bundle Simple Smile Gold': 'Simple Smile+Gold',
//     'Bundle Critical Best Care': 'Critical+Best Care',
//     'Bundle Critical Simple Smile': 'Critical+Simple Smile',
//     'Bundle Critical Gold': 'Critical+Gold',
//     'Bundle Critical Gold Plus': 'Critical+Gold Plus',
//     'Bundle Critical All-In': 'Critical+All-In'
// }

// const extraGroups = {
//     'חיוב הקמת הרשאה - ₪ 18': [{ name: 'חיוב הקמת הרשאה', sku: 'H-0010', price: 18, id: '001' }], // - 18
//     'דמי סליקה חודשיים - ₪ 3': [{ name: 'דמי סליקה חודשיים', sku: 'H-0015', price: 3, id: '002' }] // - 3
// }

// ── helpers ──────────────────────────────────────────────────
const groupByProductName = (subscriptions = [], includeExtraGroups = false) => {
    const groups = {}
    subscriptions
        .filter(sub => sub.active !== 0 && sub.product_name !== 'Mediwho Fly')
        .forEach(sub => {
            const key = sub.simplify_name // productNameMap[sub.product_name] || sub.product_name || 'ללא קבוצה'
            if (!groups[key]) groups[key] = []
            groups[key].push(sub)
        })
    return groups // includeExtraGroups ? { ...extraGroups, ...groups } : groups
}

// ── component ────────────────────────────────────────────────
@inject((store: any) => {
    const { subscriptionsStore } = store
    return { subscriptionsStore }
})
@observer
class SearchSubModal extends Component<any, any> {
    @observable _terminalType: string = this.props.terminalType

    componentDidUpdate(prevProps) {
        if (this.props.terminalType !== prevProps.terminalType) {
            action(() => {
                this._terminalType = this.props.terminalType
            })()
        }
        if (this.props.visible && !prevProps.visible) {
            if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur()
            }
            this.props.form.resetFields()
            const { subscriptions, loading, getSubscriptions } = this.props.subscriptionsStore
            if (!subscriptions.length && !loading) {
                getSubscriptions()
            }
        }
    }

    // ── handlers ─────────────────────────────────────────────
    handleClose = () => {
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur()
        }
        this.props.form.resetFields()
        this.props.onClose()
    }

    handleGroupChange = value => {
        const groups = this.groups
        const groupItems = groups[value] || []

        if (groupItems.length === 1) {
            this.props.form.setFieldsValue({ subscription_id: groupItems[0].id })
        } else {
            this.props.form.setFieldsValue({ subscription_id: undefined })
        }
    }

    handleSubmit = e => {
        e.preventDefault()
        this.props.form.validateFields((err, values) => {
            if (err) return

            const groups = this.groups
            const selected = (groups[values.product_group] || []).find(sub => sub.id === values.subscription_id)

            if (!selected) return
            this.props.onSelect(selected, this.handleClose)
        })
    }

    // ── computed ─────────────────────────────────────────────
    @computed get groups(): Record<string, any[]> {
        const { subscriptions } = this.props.subscriptionsStore
        return groupByProductName(subscriptions, this._terminalType === 'mediwhobk')
    }

    // ── render ───────────────────────────────────────────────
    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form
        const { visible } = this.props

        const { loading } = this.props.subscriptionsStore
        const groups = this.groups
        const groupNames = Object.keys(groups)
        const selectedGroup = getFieldValue('product_group')
        const groupItems = selectedGroup ? groups[selectedGroup] || [] : []

        return (
            <Modal
                width={540}
                visible={visible}
                onCancel={this.handleClose}
                maskClosable={false}
                title="בחירת מנוי"
                footer={null}
                destroyOnClose
            >
                <Form onSubmit={this.handleSubmit} layout="vertical">
                    <FormItem label="מוצר" {...rightLabel}>
                        {getFieldDecorator('product_group', {
                            rules: [{ required: true, message: 'יש לבחור קבוצה' }]
                        })(
                            <Select
                                className={selectInput}
                                placeholder="בחר מוצר"
                                onChange={this.handleGroupChange}
                                loading={loading}
                                showSearch
                                optionFilterProp="children"
                            >
                                {groupNames.map(name => (
                                    <Select.Option key={name} value={name}>
                                        {name}
                                    </Select.Option>
                                ))}
                            </Select>
                        )}
                    </FormItem>

                    <FormItem label="מנוי" {...rightLabel}>
                        {getFieldDecorator('subscription_id', {
                            rules: [{ required: true, message: 'יש לבחור מנוי' }]
                        })(
                            <Select
                                className={selectInput}
                                placeholder="בחר מנוי"
                                disabled={!selectedGroup || loading}
                                loading={loading}
                                showSearch
                                optionFilterProp="children"
                            >
                                {groupItems.map(sub => (
                                    <Select.Option key={sub.id} value={sub.id}>
                                        {sub.sku} - {sub.name} ({sub.price} ₪)
                                    </Select.Option>
                                ))}
                            </Select>
                        )}
                    </FormItem>

                    <Row type="flex" justify="end">
                        <Button type="primary" htmlType="submit">
                            בחר
                        </Button>
                    </Row>
                </Form>
            </Modal>
        )
    }
}

export default Form.create()(SearchSubModal) as any
